module.exports = "pegasus_template/assets/space.png";